"use client";

import { c as _c } from "react/compiler-runtime";
import { getCurrencyKey, useChains } from "@opensea/app-kit";
import { FlexColumn, Input, Item, ItemAction, ItemAvatar, ItemContent, ItemDescription, ItemTitle, NumberDisplay, SpaceBetween, TextBody, Tooltip, UnstyledButton } from "@opensea/ui-kit";
import { ChevronRight, SwapVert } from "@opensea/ui-kit/icons";
import { useCallback, useState } from "react";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../../components/Avatar";
import { CurrencyQuantityPresetButton } from "../../../../components/CurrencyQuantityInput/CurrencyQuantityPresetButton";
import { CurrencySelectSheet } from "../../../../components/CurrencyQuantityInput/CurrencySelectSheet";
import { useSyncFormFields } from "../../../../hooks/useSyncFormField";
import { useBalances } from "../../../../providers/BalancesProvider";
import { convertTokenToUsd, convertUsdToToken } from "../helpers";
import { useSendQuote } from "../provider/SendProvider";
export function TokenQuantityInput(t0) {
  const $ = _c(91);
  const {
    container
  } = t0;
  const t = useTranslations("wallet.TokenQuantityInput");
  const [isSelectingCurrency, setIsSelectingCurrency] = useState(false);
  const {
    getBalanceOfCurrency
  } = useBalances();
  const {
    currency,
    setCurrency
  } = useSendQuote();
  const [currencyMode, setCurrencyMode] = useState("token");
  const {
    getName: getChainName,
    getLogo: getChainLogo
  } = useChains();
  const {
    setValue: setFormValue,
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    errors
  } = useFormState(t1);
  let t2;
  if ($[2] !== currency || $[3] !== getBalanceOfCurrency) {
    t2 = getBalanceOfCurrency(currency);
    $[2] = currency;
    $[3] = getBalanceOfCurrency;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const balance = t2;
  const t3 = Number(balance?.quantity);
  let t4;
  if ($[5] !== t3) {
    t4 = [{
      name: "ownedQuantity",
      value: t3
    }];
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== setFormValue || $[8] !== t4) {
    t5 = {
      fields: t4,
      setValue: setFormValue
    };
    $[7] = setFormValue;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useSyncFormFields(t5);
  let t6;
  if ($[10] !== control) {
    t6 = {
      control,
      name: "quantity"
    };
    $[10] = control;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const quantity = useWatch(t6);
  const [displayValue, setDisplayValue] = useState(quantity);
  let t7;
  if ($[12] !== currency || $[13] !== currencyMode || $[14] !== quantity) {
    t7 = currencyMode === "token" ? convertTokenToUsd(quantity, currency) : quantity;
    $[12] = currency;
    $[13] = currencyMode;
    $[14] = quantity;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const alternateValue = t7;
  let t8;
  if ($[16] !== setCurrency || $[17] !== setFormValue) {
    t8 = currency_0 => {
      setCurrency(currency_0);
      setFormValue("quantity", "0");
      setDisplayValue("0");
      setIsSelectingCurrency(false);
    };
    $[16] = setCurrency;
    $[17] = setFormValue;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const handleCurrencyChange = t8;
  let t9;
  if ($[19] !== currency || $[20] !== currencyMode || $[21] !== setFormValue) {
    t9 = val => {
      setDisplayValue(val);
      const fieldValue = currencyMode === "usd" ? convertUsdToToken(val, currency) : val;
      setFormValue("quantity", fieldValue, {
        shouldValidate: true
      });
    };
    $[19] = currency;
    $[20] = currencyMode;
    $[21] = setFormValue;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handleQuantityChange = t9;
  let t10;
  if ($[23] !== alternateValue) {
    t10 = () => {
      setDisplayValue(alternateValue);
      setCurrencyMode(_temp);
    };
    $[23] = alternateValue;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const handleSwitchCurrencyMode = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsSelectingCurrency(true);
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== currency.chainIdentifier || $[27] !== getChainLogo || $[28] !== getChainName || $[29] !== t) {
    t12 = currency.chainIdentifier ? <Tooltip content={t("chain", {
      name: getChainName(currency.chainIdentifier)
    })}><Avatar.Badge className="bg-black" size="md"><Avatar className="text-white" title={getChainName(currency.chainIdentifier)} {...getChainLogo(currency.chainIdentifier)} /></Avatar.Badge></Tooltip> : undefined;
    $[26] = currency.chainIdentifier;
    $[27] = getChainLogo;
    $[28] = getChainName;
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== currency) {
    t13 = getCurrencyKey(currency);
    $[31] = currency;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== currency.imageUrl || $[34] !== t12 || $[35] !== t13) {
    t14 = <ItemAvatar badge={t12} className="rounded-full bg-white" seed={t13} size={40} src={currency.imageUrl} />;
    $[33] = currency.imageUrl;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== currency.symbol) {
    t15 = <ItemTitle>{currency.symbol}</ItemTitle>;
    $[37] = currency.symbol;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const t16 = balance?.quantity ?? 0;
  let t17;
  if ($[39] !== currency.symbol || $[40] !== t16) {
    t17 = <ItemDescription><NumberDisplay suffix={currency.symbol} value={t16} /></ItemDescription>;
    $[39] = currency.symbol;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t15 || $[43] !== t17) {
    t18 = <ItemContent>{t15}{t17}</ItemContent>;
    $[42] = t15;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ItemAction><UnstyledButton><ChevronRight className="rotate-90" fill="text-secondary" /></UnstyledButton></ItemAction>;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t14 || $[47] !== t18) {
    t20 = <Item className="rounded-md border-none bg-bg-additional-1 px-4 py-3.5 hover:cursor-pointer hover:bg-bg-additional-2" onClick={t11}>{t14}{t18}{t19}</Item>;
    $[46] = t14;
    $[47] = t18;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== currency || $[50] !== currencyMode || $[51] !== handleQuantityChange) {
    t21 = presetQuantity => {
      const display = currencyMode === "usd" ? convertTokenToUsd(String(presetQuantity), currency) : String(presetQuantity);
      handleQuantityChange(display);
    };
    $[49] = currency;
    $[50] = currencyMode;
    $[51] = handleQuantityChange;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  const t22 = typeof quantity === "string" && quantity !== "" ? Number(quantity) : undefined;
  let t23;
  if ($[53] !== balance || $[54] !== t21 || $[55] !== t22) {
    t23 = <CurrencyQuantityPresetButton balance={balance} balanceMultiplier={1} onClick={t21} quantity={t22} requiresSvmFee={false} />;
    $[53] = balance;
    $[54] = t21;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  const t24 = Boolean(errors.quantity);
  let t25;
  if ($[57] !== handleQuantityChange) {
    t25 = e => handleQuantityChange(e.target.value);
    $[57] = handleQuantityChange;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  const t26 = currencyMode === "usd" ? "$" : null;
  let t27;
  if ($[59] !== displayValue || $[60] !== t23 || $[61] !== t24 || $[62] !== t25 || $[63] !== t26) {
    t27 = <SpaceBetween className="items-center"><Input className="!bg-bg-additional-1 py-7 font-mono" endEnhancer={t23} error={t24} onChange={t25} placeholder="0" size="md" startEnhancer={t26} type="number" value={displayValue} /></SpaceBetween>;
    $[59] = displayValue;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== alternateValue || $[66] !== currency.symbol || $[67] !== currencyMode || $[68] !== errors.quantity) {
    t28 = errors.quantity ? <TextBody color="error-1" size="xs">{errors.quantity.message}</TextBody> : <TextBody className="font-mono" size="xs"><NumberDisplay display={currencyMode === "usd" ? "standard" : "usd"} suffix={currencyMode === "usd" ? currency.symbol : "USD"} value={alternateValue} /></TextBody>;
    $[65] = alternateValue;
    $[66] = currency.symbol;
    $[67] = currencyMode;
    $[68] = errors.quantity;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SwapVert size={16} />;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  const t30 = currencyMode === "token" ? "USD" : currency.symbol;
  let t31;
  if ($[71] !== t || $[72] !== t30) {
    t31 = t("switchTo", {
      currency: t30
    });
    $[71] = t;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== handleSwitchCurrencyMode || $[75] !== t31) {
    t32 = <UnstyledButton className="text-secondary text-sm" onClick={handleSwitchCurrencyMode}>{t29}{t31}</UnstyledButton>;
    $[74] = handleSwitchCurrencyMode;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== t28 || $[78] !== t32) {
    t33 = <SpaceBetween>{t28}{t32}</SpaceBetween>;
    $[77] = t28;
    $[78] = t32;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] !== t20 || $[81] !== t27 || $[82] !== t33) {
    t34 = <FlexColumn className="gap-3">{t20}{t27}{t33}</FlexColumn>;
    $[80] = t20;
    $[81] = t27;
    $[82] = t33;
    $[83] = t34;
  } else {
    t34 = $[83];
  }
  let t35;
  if ($[84] !== container || $[85] !== handleCurrencyChange || $[86] !== isSelectingCurrency) {
    t35 = <CurrencySelectSheet container={container} direction="from" onOpenChange={setIsSelectingCurrency} onSelectCurrency={handleCurrencyChange} open={isSelectingCurrency} removeSwapDisabledCurrencies={false} />;
    $[84] = container;
    $[85] = handleCurrencyChange;
    $[86] = isSelectingCurrency;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  let t36;
  if ($[88] !== t34 || $[89] !== t35) {
    t36 = <>{t34}{t35}</>;
    $[88] = t34;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  return t36;
}
function _temp(prevMode) {
  return prevMode === "token" ? "usd" : "token";
}